export default "__VITE_ASSET__BRlbUEqv__"